import { create } from 'zustand'

// Lets surfaces outside this feature (e.g. the command palette) open the
// bug-report modal: they set the request flag, and the mounted ReportBug
// container observes it and runs its full openModal flow (tracking +
// auto-screenshot) rather than the flag toggling the modal directly.
export interface BugReportUIState {
  isOpenRequested: boolean
  requestOpen: () => void
  clearOpenRequest: () => void
}

export const useBugReportUIStore = create<BugReportUIState>()((set) => ({
  isOpenRequested: false,
  requestOpen: () => set({ isOpenRequested: true }),
  clearOpenRequest: () => set({ isOpenRequested: false }),
}))
